export default __webpack_public_path__ + "static/media/item-2-safari-14.b59fa230.png";